import { render } from "./TiktokRedirectView.vue?vue&type=template&id=5a2bc828"
import script from "./TiktokRedirectView.vue?vue&type=script&lang=js"
export * from "./TiktokRedirectView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__